import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { IAdminUserInfo } from "../components/organisms/AdminRegisterModal";
import history from "../history";
import axios from "../modules/axiosInstance";

import { API_HOST } from "../config";

interface IAdminEditModal extends IAdminUserInfo {
  changedPassword: string;
}

const useAdminUserContainer = () => {
  const [profileEditForm, changeProfileEditForm] = useState<IAdminEditModal>({
    name: "",
    email: "",
    password: "",
    changedPassword: ""
  });

  useEffect(() => {
    const admin_id = Cookies.get("admin_id");
    const url = `${API_HOST}/api/admins/${admin_id}`;
    axios
      .get<IAdminUserInfo>(url)
      .then(r => {
        const data = r.data;
        changeProfileEditForm({
          ...profileEditForm,
          name: data.name,
          email: data.email
        });
      })
      .catch(e => {
        console.error(e);
        history.push("/login");
      });
  }, []);

  return { profileEditForm, changeProfileEditForm };
};

export const AdminuUserContainer = createContainer(useAdminUserContainer);
